import { toast } from 'react-toastify';
import * as api from '../api/visitApi';
import * as types from '../constants/visitConstans';

const FileDownload = require('js-file-download');

export const getVisitAction = (visitId, vin) => async (dispatch) => {
  dispatch({ type: types.GET_VISIT_REQUEST });
  try {
    const { error, data } = await api.getVisit(visitId, vin);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_VISIT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити візит');
    dispatch({ type: types.GET_VISIT_FAILURE });
  }
};

export const updateVisitAction = (vin, visitId, visit) => async (dispatch) => {
  try {
    const { error, data } = await api.updateVisit(vin, visitId, visit);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_VISIT_SUCCESS,
      payload: data,
    });
    toast.success('Візит був успішно змінений');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити візит');
    dispatch({ type: types.GET_VISIT_FAILURE });
  }
};

export const downloadInvoiceAction = (vin, visitId) => async () => {
  try {
    const response = await api.downloadInvoice(vin, visitId);
    const fileName = `${vin}-${String(visitId).padStart(7, '0')}.pdf`;
    FileDownload(response.data, fileName);
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити наряд-замовлення');
  }
};

export const deleteVisitActions = (vin, visitId) => async () => {
  try {
    await api.deleteVisit(vin, visitId);
    toast.success('Візит було успішно видалено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити візит');
  }
};

export const completeVisitAction = (vin, visitId) => async (dispatch) => {
  try {
    await api.completeVisit(vin, visitId);
    toast.success('Візит було успішно завершено');
    dispatch(getVisitAction(visitId, vin));
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити візит');
  }
};

export const splitVisitAction = (vin, visitId, body) => async (dispatch) => {
  try {
    await api.splitVisit(vin, visitId, body);
    toast.success('Візит було успішно розділено');
    await dispatch(getVisitAction(visitId, vin));
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити візит');
  }
};

export const clearVisitAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_VISIT,
  });
};
